<template>
	<Modal
		v-if="autoApplyLimitReached"
		:allow-close="false"
		:hide-actions="true"
		:max-width="'max-w-[485px]'"
		rounded-size="rounded-[10px]"
		:prevent-scrolling="false"
		:remove-padding="true"
	>
		<template #body>
			<!-- pb-4, not the design's 24px: Modal's body wrapper already adds mb-2 below the slot. -->
			<div class="flex flex-col gap-4 pb-4 font-[Inter]">
				<div class="flex h-24 items-center justify-center bg-won-green-light">
					<div class="relative">
						<div class="flex h-11 items-center rounded-lg bg-won-green px-5 opacity-35">
							<SparklesIcon class="size-6 text-white" />
							<span class="px-1 text-p-base leading-5 font-medium text-white">AutoApply</span>
						</div>
						<img
							:src="CLOCK_IMAGE"
							alt=""
							width="32"
							height="32"
							class="absolute -top-2 -right-2"
						/>
					</div>
				</div>

				<div class="flex flex-col gap-2 px-6">
					<h2 class="text-xl leading-7 font-semibold text-gray-900">
						AutoApply Technical Limit
					</h2>
					<p class="text-sm leading-5 text-gray-500">
						You've reached the technical limit for AutoApply this month. We've been notified and will unlock it for you soon.
					</p>
				</div>

				<div class="flex justify-end gap-2 px-6">
					<button
						type="button"
						class="h-9 rounded-md px-4 text-sm font-medium text-gray-900 hover:bg-gray-100"
						@click="store.closeAutoApplyLimitReached()"
					>
						Back to Jobs
					</button>
					<button
						v-if="autoApplyLimitReached.job?.apply_url"
						type="button"
						class="h-9 rounded-md bg-won-green px-4 text-sm font-medium text-white hover:bg-won-green/90"
						@click="applyManually"
					>
						Apply Manually
					</button>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import { SparklesIcon } from '@heroicons/vue/24/outline';

import Modal from '../components/modal.vue';
import { useAutoApplyJobsStore } from '../store/auto-apply.store';
import { useExternalApply } from '../composables/use-external-apply';

// public/img assets need a bound :src — a literal src attribute breaks Vite's import analysis.
const CLOCK_IMAGE = '/img/auto-apply-limit-clock.svg';

/**
 * EN-1314: shown instead of the upgrade paywall when a paid user reaches the AutoApply technical limit —
 * they have already paid, so the answers are that we have been notified and will unlock it, and how to
 * apply to this job without AutoApply in the meantime.
 */
const store = useAutoApplyJobsStore();
const { autoApplyLimitReached } = storeToRefs(store);
const { openExternalApply } = useExternalApply();

// Opens the employer's site first, inside the click, so Safari does not block the popup.
const applyManually = () => {
	openExternalApply(autoApplyLimitReached.value.job);
	store.closeAutoApplyLimitReached();
};
</script>
